import { React } from '@/vendor'

export default (props) => (
	<svg width={12} height={8} viewBox="0 0 12 8" {...props}>
		<path d="M1.04 2.4h9.92a.5.5 0 01.39.812l-4.96 6.2a.5.5 0 01-.78 0l-4.96-6.2a.5.5 0 01.39-.812z" />
	</svg>
)
